import type { NskResponse } from "~/models/Api";
import type { DealVendorNoteParam } from "~/models/DealVendorNote";
import { postRequest, putRequest } from "~/utils/api/api_handler";

const paths = {
	create: "/vendors/deals/:deal_id/deal_vendor_notes",
	update: "/vendors/deals/:deal_id/deal_vendor_notes/:id"
};

export const create = async (
	dealVendorNoteParams: DealVendorNoteParam,
	dealId: number
): Promise<NskResponse> =>
	postRequest(paths.create.replace(":deal_id", String(dealId)), {
		note: dealVendorNoteParams.note
	});

export const update = async (
	dealVendorNoteParams: DealVendorNoteParam,
	dealVendorNoteId: number,
	dealId: number
): Promise<NskResponse> =>
	putRequest(
		paths.update
			.replace(":id", String(dealVendorNoteId))
			.replace(":deal_id", String(dealId)),
		{ note: dealVendorNoteParams.note, version: dealVendorNoteParams.version }
	);
